import * as React from 'react';

import { ChatMessageType } from '@common/react/objects/Chat';
import { getChatMessageMarkup, transformMentionMessage } from '@common/react/components/Chat/ChatUtils';
import { imageExtensions } from '@common/react/components/Chat/Chats';

export const ChatLastMessageTypeDictionary = {
	[ChatMessageType.Regular]: ({message, chat, userId}) => {
		const currentUser = message.userId === userId ? 'You: ' : '';
		if (message.text) {
			return <div
				className="chat-list__item-last-message"
				dangerouslySetInnerHTML={{
					__html: getChatMessageMarkup((currentUser)
						+ transformMentionMessage(message.text, chat.contacts, false))
				}}
			/>;
		}

		const fileCount = message.files.length;
		const images = message.files.filter(f => imageExtensions.includes(f.file.extension?.toLowerCase()));

		if (images.length) {
			return <div className="chat-list__item-last-message">
				{currentUser}
				{images.map(image => <img
					key={image.file.id}
					src={image.file.src}
					alt={image.file.name}
					className="chat-file-tag-image"
					title={image.file.name}
				/>)}
			</div>;
		}

		return <div className="chat-list__item-last-message">
			{currentUser}
			<i className="fa fa-file" style={{marginRight: 5, marginLeft: currentUser ? 5 : 0}}/>
			{fileCount ? fileCount === 1 ? 'sent a file' : 'sent files' : ''}
		</div>;
	},
	[ChatMessageType.Email]: ({message, userId}) => <div className="chat-list__item-last-message">
		{message.userId === userId ? 'You: ' : ''} sent email
	</div>,
	[ChatMessageType.PhoneCall]: ({message}) => <div className="chat-list__item-last-message">
		<i className="fa fa-phone-square" style={{color: 'red'}}/>
	</div>,
	[ChatMessageType.VideoChat]: ({message}) => <div className="chat-list__item-last-message">
		<i className="fa fa-video-camera" style={{color: 'red'}}/>
	</div>,
	[ChatMessageType.VoiceMessage]: ({message, userId}) => <div className="chat-list__item-last-message">
		{message.userId === userId ? 'You: ' : ''}
		<i className="fa fa-file-audio-o" style={{marginRight: 5, marginLeft: message.userId === userId ? 5 : 0}}/>voice
		message
	</div>,
	[ChatMessageType.VideoMessage]: ({message, userId}) => <div className="chat-list__item-last-message">
		{message.userId === userId ? 'You: ' : ''}
		<i className="fa fa-video-camera" style={{marginRight: 5, marginLeft: message.userId === userId ? 5 : 0}}/>video
		message
	</div>,
	[ChatMessageType.Email]: ({message, userId}) => <div className="chat-list__item-last-message">
		{message.userId === userId ? 'You: ' : ''} sent email
	</div>
};
